export default "__VITE_ASSET__DSCzmUDf__"